$(function () {

// Ввод только цифр
	$('.js-number').keypress(function(e){
		let charCode = (e.which) ? e.which : e.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		  return false;
		}
	});

// Деактивация кнопки отправки формы при снятии галочки с чекбокса согласия
	$('body').on('change', '.js-agree', function () {
		let $this = $(this);
		let btn = $this.closest('.js-form').find('.submit');
		if ($this.is(':checked')) {
			btn.removeAttr("disabled");
		} else {
			btn.attr("disabled", true);
		}
	});


// Валидация формы
	let formValidate = function() {

		let form = $('.js-form');

		form.each(function(){
			let thisForm = $(this);
			let url = thisForm.attr('action');


			// Добавление метода валидации для телефона
				$.validator.addMethod("fullPhone", function(value, element) {
					let phoneInput = thisForm.find('input[name=phone]').val();		
				
					console.log(value.replace(/\D/g, '').length); 
					return value.replace(/\D/g, '').length >= 11; // Пример: минимальная длина телефона 10 символов
			}, "Номер телефона введен не полностью");

			thisForm.validate({
				focusInvalid: false,
				rules: {
					phone: { 
							fullPhone: true
					}
				},
				messages: {
						phone: {
								fullPhone: "Номер телефона введен не полностью" 
						}
				},
				highlight: function(element) {
				  $(element).closest(".form-field").addClass('form-field--error');
				},
				unhighlight: function(element) {
				  $(element).closest(".form-field").removeClass('form-field--error');
				},
				submitHandler: function(form, event){
					event.preventDefault(); 

						
					let formData = new FormData(thisForm[0]); 

					formData.delete('phone');	 
					formData.set('phone',thisForm.find(".iti__selected-dial-code").text()+thisForm.find('input[name=phone]').val()); 

					let successpopup=thisForm.data("thank")

					$.ajax({
						url: '/wp-admin/admin-ajax.php',
						type: 'POST',
						processData: false,
						contentType: false,
						data: formData, 
						// dataType: "json",
						success: function(data) {
							console.log(data);
							openPopup(successpopup, "", ""); 
							setTimeout(function(){
								$('.thank-popup').removeClass('is-show');
								thisForm.trigger("reset");
							},4000);  
						}  
					});


					return false;
				}
			});

		});
	};

	formValidate();

	window.formValidate = formValidate;




	

	$B.on('click', 'label.error',function(){
		$(this).hide().siblings('input,textarea').focus();

	});

	// $B.on('keyup', 'input',function(){
	// 	$(this).siblings('label.error').hide();
	// });

	$B.on('change', '.js-select', function(){
		console.log('rfd')
		$(this).closest('.form-field').removeClass('form-field--error');
	})

	$('.popup-thank').on('click', function(){
		$(this).removeClass('is-show');
	});

});


